import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-push-subscription-modal',
  imports: [CommonModule ],
  templateUrl: './push-subscription-modal.component.html',
  styleUrls: ['./push-subscription-modal.component.scss']
})
export class PushSubscriptionModalComponent {
  @Output() subscribe = new EventEmitter<void>();
  @Output() skip = new EventEmitter<void>();
  public processing: boolean = false;

  onSubscribe() {
    this.processing = true;
    this.subscribe.emit();
  }

  onSkip() {
    this.processing = true;
    this.skip.emit();
  }
}
